/**
 * Form controller mixin
 */

/**
 * formCtrlMixinFactory
 * returns formCtrlMixin mixin factory
 *
 * @class formCtrlMixinFactory
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc factory
 * @name mwApp/common.factory:formCtrlMixinFactory
 */
/* @ngInject */
export default function formCtrlMixinFactory () {
  let disableButton = false

  return {
    /**
     * Is disable check
     *
     * @returns {boolean}
     */
    isDisabled: function () {
      return disableButton
    },

    /**
     * Set disable indicator
     */
    setDisable: function () {
      disableButton = true
    },

    /**
     * Unset disable indicator
     */
    unsetDisable: function () {
      disableButton = false
    },

    /**
     * Checking for form validation and form save readiness
     * Only gate on async in-flight state — do not tie to form.$invalid after $submitted.
     * Some fields (e.g. paired contenteditable + hidden input, custom date validity) can
     * leave $invalid stale; disabling Save then traps the user after a failed first submit.
     */
    saveDisabled: function (form) {
      return this.isDisabled()
    },

    /**
     * Checking for form validation and form update readiness
     */
    updateDisabled: function (form) {
      /** @todo improve validation logic
       * ((form.$submitted || form.$dirty) && form.$invalid) || form.$pristine
       */
      return (form?.$submitted && form?.$invalid) || form?.$pristine
    }
  }
}
